import { Eye, ExternalLink } from "lucide-react";
import { Button } from "./button";

interface SeoPreviewProps {
  pageTitle: string;
  pageDescription: string;
  url: string;
  siteName?: string;
  previewUrl?: string;
}

export function SeoPreview({
  pageTitle,
  pageDescription,
  url,
  siteName = "Website Của Bạn",
  previewUrl,
}: SeoPreviewProps) {
  // Extract display URL (remove protocol and trailing slash)
  const displayUrl = url.replace(/^https?:\/\//, "").replace(/\/$/, "");

  // Truncate title if too long (Google typically shows ~60 chars)
  const truncatedTitle =
    pageTitle.length > 60 ? pageTitle.slice(0, 57) + "..." : pageTitle;

  // Truncate description if too long (Google typically shows ~155-160 chars)
  const truncatedDescription =
    pageDescription.length > 160
      ? pageDescription.slice(0, 157) + "..."
      : pageDescription;

  const handleOpenPreview = () => {
    if (previewUrl) {
      window.open(previewUrl, "_blank");
    }
  };

  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl border border-blue-100 overflow-hidden">
      {/* Header */}
      <div className="flex items-center gap-2 px-4 py-3 bg-white/50 border-b border-blue-100">
        <Eye className="h-4 w-4 text-blue-600" />
        <span className="font-medium text-gray-700">Xem Trước</span>
      </div>

      {/* Google Search Preview */}
      <div className="p-4">
        <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100">
          {/* Title - Google style */}
          <h3 className="text-xl text-blue-700 hover:underline cursor-pointer leading-snug mb-1 font-normal">
            {truncatedTitle || "Tiêu đề trang"} - {siteName}
          </h3>

          {/* URL - Google style */}
          <div className="text-sm text-green-700 mb-2 truncate">
            {displayUrl || "example.com/trang-cua-ban"}
          </div>

          {/* Description */}
          <p className="text-sm text-gray-600 leading-relaxed">
            {truncatedDescription || "Mô tả trang sẽ hiển thị ở đây..."}
          </p>
        </div>

        {/* Open Preview Button */}
        {previewUrl && (
          <div className="mt-4">
            <Button
              type="button"
              variant="outline"
              onClick={handleOpenPreview}
              className="w-full gap-2 bg-white hover:bg-blue-50 border-blue-200 text-blue-700"
            >
              <ExternalLink className="h-4 w-4" />
              Mở URL Nháp
            </Button>
          </div>
        )}

        {/* Draft URL Info */}
        {previewUrl && (
          <div className="mt-3 text-xs text-gray-500 space-y-1">
            <p className="truncate">
              <span className="font-medium">URL Nháp:</span>{" "}
              <span className="text-blue-600">{previewUrl}</span>
            </p>
            <p className="text-gray-400 italic">
              Mô phỏng đường dẫn xem trước chỉ hiển thị khi đăng nhập.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
